import { round } from "./round";
import { lerp } from "./lerp";

export const lerpRounded = (min: number, max: number, t: number, decimalPoint = 0): number =>
  round(lerp(min, max, t), decimalPoint);
